import React from 'react';
import { useTranslation } from 'react-i18next';
import { HelpCircle } from 'lucide-react';
import { useExplain } from './ExplainContext';

// F25 — permanent entry to a feature's full-screen explainer, for after the
// dismissible explain card is gone. Unified across the app as a rectangular
// ghost button holding just the "?" icon (no label); opens the
// provider-hosted ExplainPage.
const HowItWorksButton = ({ feature, className = '' }) => {
    const { t } = useTranslation();
    const { openPage } = useExplain();

    return (
        <button
            type="button"
            className={`btn btn-ghost how-it-works-btn ${className}`}
            onClick={() => openPage(feature)}
            aria-label={t('explain.howItWorks')}
            title={t('explain.howItWorks')}
        >
            <HelpCircle size={18} />
        </button>
    );
};

export default HowItWorksButton;
